import React, { Suspense } from 'react';
// import { Wrapper1 } from '../udb/bonus/BonusHomepage';
import Intl from 'src/components/common/Intl';
import styled, { withTheme } from 'styled-components';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { theme } from 'styled-tools';
import config from 'src/config/config';

const LoyaltyComponent = React.lazy(() => import('./LoyaltyComponent'));

 function LoyaltyHomeComponent(props) {
  const { theme } = props;
  const { config: { showtier = true } } = theme;
  return showtier ? (
    <LoyaltyHomeWrapper>
      <LazyLoadComponent>
        <Wrapper>
          <h3><Intl langKey="TITLE@LOYALTYTAGLINE" /></h3>
        </Wrapper>
      </LazyLoadComponent>
    
      <Suspense fallback={<div>Loading...</div>}>
          <LoyaltyComponent />
      </Suspense>
      <KnowMoreBtn href="/loyalty"><Intl langKey="BUTTON@KnowMoreBtn" /></KnowMoreBtn>
    </LoyaltyHomeWrapper>
  ): null
}

export default withTheme(LoyaltyHomeComponent)

//Styled Components
const KnowMoreBtn = styled.a`
    margin: 0;
    border: none;
    /* background: ${theme('palette.secondary-background-color-linear-new1')}; */
    background: ${theme('palette.loyaltyHomeComponentKnowMoreBtnBg')};
    border-radius: 5px;
    padding: 10px 35px;
    color: ${theme('palette.loyaltyHomeComponentKnowMoreBtnColor')};
    font-weight: 600;
    font-size: 18px;
    text-align: center;
    position: absolute;
    right: 3%;
    bottom: 20px;
    text-transform: uppercase;

    &:hover {
      background: ${theme('palette.knowMoreBtnHover')};
    }
`;

const LoyaltyHomeWrapper = styled.div`
  width: 100%;
  position: relative;
`;

const Wrapper = styled.div`
    width: 100%;
    height: ${theme('palette.LoyaltyHomePageTittleHeight')};
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    padding-bottom: 5px;
    background-image: url(${config.imageV3Host}/static/cashsite/${theme('image.new_whitelable_separator_v2_homepage')});
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: ${theme('palette.bonusHomePageTittlePaddingTop')};
   

    h3 {
        display: flex;
        color: ${theme('palette.homeTittleTexts')};
        text-transform: uppercase;
        font-size: 30px;
        letter-spacing: 0.05em;
        margin: 0;
        line-height: 35px;
        padding-left: 40px;

        @media only screen and (min-width: 1800px){
            font-size: 35px;
        }
    }
    h2{
        display: flex;
        flex-direction: column;
        color: ${theme('palette.homeTittleTexts')};
        text-transform: uppercase;
        font-size: 25px;
        letter-spacing: 0.05em;
        margin: 0;
        line-height: 35px;
        padding-left: 40px;

        @media only screen and (min-width: 1800px){
            font-size: 35px;
        }
    }
`;
